import React from "react";

function Facilities() {
    const facilities = [
        "Treatment for all common health problems.",
        "Availability of Anti Snake Venom and Anti Rabies Vaccine.",
        "Full equipped ambulance(24X7).",
        "Separate wards for male and female.",
        "Availability of all emergency equipment's- Defibrillator, Multipara cardiac Monitor, ECG machine, Oxygen concentrators, Suction apparatus.",
        "Timely providing health education.",
    ];
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h1>Facilities</h1>
            <ul>
                {facilities.map((facility, index) => (
                    <li
                        key={index}
                        className="caboutus"
                        style={{ display: "flex", flexDirection: "row" }}
                    >
                        <i
                            className="icon fal fas fa-caret-right pl-5"
                            style={{
                                display: "block",
                                alignSelf: "flex-start",
                                marginTop: "0.31lh",
                            }}
                        />
                        <p className="pl-5">{facility}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Facilities;
